// @index('./*.png', (f, _) => `import { default as ${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as 猜你喜欢 } from './猜你喜欢.png'
// @endindex

export const MayConsumerCouponImages = {
  // @index('./*.png', (f, _) => `${_.pascal(f.name)},`)
  猜你喜欢,
  // @endindex
}
